module.exports = __webpack_public_path__ + "assets/images/base_roads_phase2.145f99213399411a64c579aa4570dd9d.svg";